var edit_group_template = require('./edit_group.twig');
import { Dropdown } from '../../components/Dropdown'

export class EditGroup
{
    constructor(config) {
        this.config = config
        this.groupId = config.groupId
        this.members = [];
        this.search_targets_with_mdas = app.appData.configs?.SEARCH_TARGETS_WITH_MDAS ?? false;

        this.dom = $(twig({ data: edit_group_template }).render({config: config}))

        let statesDD = new Dropdown(app.appData.states)
        statesDD
            .label('State')
            .draw(this.dom.find("#target_search_state_dd-container"), 'alpha2', 'name', 'state')
        this.dom.find('#target_search_state_dd-container > select').addClass("input-group-text")

        this.initializeTables()
        this.loadMembersTable()

        this.dom.find('#datatable_targets').on('click', '.add', (event) => {
            let targetData = this.targetsDatatable.row($(event.target).closest('tr')).data()
            this.addMember(targetData)

            event.preventDefault()
        })

        this.dom.find('#datatable_members').on('click', '.delete', (event) => {
            let memberData = this.membersDatatable.row($(event.target).closest('tr')).data()
            if(confirm('Are you sure you want to remove ' + memberData.firstname + ' ' + memberData.lastname + '?')) {
                this.deleteMember(memberData.target_id)
            }

            event.preventDefault()
        })

        this.dom.find('#target_search_firstname, #target_search_lastname').on('keyup', () => {
            this.dom.find("#target_filter button").prop("disabled", !this.canSearch());
        });

        this.dom.find('#state').on('change', () => {
            this.dom.find("#target_filter button").prop("disabled", !this.canSearch());
        });

        this.dom.find('#form_filter_targets').on('submit', (e) => {
            e.preventDefault()

            this.setFilterData()
            this.targetsDatatable.ajax.reload();
        });


        this.dom.find('#back-to-groups').on('click', (e) => {
            e.preventDefault()
            this.dom.trigger('ShowManageGroups', [e])
            this.modal.hide()
        });

        this.dom.on('hidden.bs.modal',  () => {
            this.modal.dispose();
        })

        this.modal = new bootstrap.Modal(this.dom, {backdrop: 'static', keyboard: false});
        this.modal.show();
    }

    setFilterData() {
        this.filterData = {};
        this.dom.find("#form_filter_targets input, #form_filter_targets select").each((index ,elem) => {
            this.filterData[$(elem).attr('name').replace('target_search_', '')] = $(elem).val();
        });
    }

    canSearch() {
        let ipt_validation = {
            firstname:      (this.dom.find('#target_search_firstname').val() ?? '').trim().length > 1,
            lastname:       (this.dom.find('#target_search_lastname').val() ?? '').trim().length > 1,
            state:          !['', null].includes((this.dom.find('#state').val() ?? '')),
        };

        let criteria = JSON.parse(app.appData.configs.SEARCH_UNIVERSE_MINIMUM_CRITERIA ?? '["lastname"]');
        if(criteria.length > 0){
            // If any rules have been specified, make sure each of them passes their check
            let pass_count = 0;
            for(let ipt in criteria){
                if(ipt_validation[criteria[ipt]] && ipt_validation[criteria[ipt]] === true){
                    pass_count++;
                }
            }

            if(pass_count == criteria.length){
                return true;
            }
        }else{
            // If no rules have been specified, make sure at least 1 input contains data to search with
            for(let key in ipt_validation){
                if(ipt_validation[key] === true){
                    return true;
                }
            }
        }

        return false;
    }

    deleteMember(targetId) {
        return $.ajax({
            url : `/api/attendance-group/${this.groupId}/members/${targetId}`,
            type : 'DELETE'
        }).then((response) => {
            if(response.success) {
                this.membersDatatable.row('#member-' + targetId).remove().draw()

                displayNotification({
                    message: 'Member deleted.',
                    success: true
                })
            }

            return response
        })
    }

    addMember(memberData) {
        console.log(memberData)
        return $.ajax({
            url: `/api/attendance-group/${this.groupId}/members`,
            type: 'POST',
            data: {
                'target_id': memberData.target_id,
                'customer_id': memberData.customer_id ?? 0,
                'address_id': memberData.address_id,
                'address_index': memberData.address_index ?? 0
            },
            dataType: 'JSON'
        }).then((response) => {
            if(response.success) {
                this.loadMembersTable()
                displayNotification({
                    message: 'Member added.',
                    success: true
                })
                let id = this.search_targets_with_mdas ? '.add[data-customer-id="' + memberData.customer_id + '"]' : '.add[data-target-id="' + memberData.target_id + '"]';
                this.dom.find(id).each((index, elem) => {
                    elem.remove()
                })

            } else {
                displayNotification({
                    message: response.message,
                    success: false
                })
            }

            return response
        })
    }

    getMembers() {
        return $.ajax({
            url: `/api/attendance-group/${this.groupId}/members`,
            type: 'GET'
        })
    }

    loadMembersTable() {
        this.getMembers().then((response) => {
            this.members = response.data
            this.membersDatatable.clear()
            this.membersDatatable.rows.add(response.data).draw()
        })
    }

    initializeTables() {
        this.membersDatatable = this.dom.find('#datatable_members').DataTable({
            "data": this.members,
            "rowId": (data) => { return "member-" + data.target_id },
            "displayLength": 10,
            "sort": true,
            "paginate": true,
            "filter": false,
            "paginationType": "full_numbers",
            "columns": [
                {"mDataProp": "customer_id"},
                {"mDataProp": "firstname"},
                {"mDataProp": "lastname"},
                {"mDataProp": "degree"},
                {"mDataProp": "specialty"},
                {"mDataProp": "address1"},
                {"mDataProp": "city"},
                {"mDataProp": "state"},
                {"mDataProp": "email"},
                {
                    "data": null,
                    "render": (data, type, row) => {
                        let html = `<a class="delete mx-1" data-target-id="${row['target_id']}" title='Remove Member'><i class="fas fa-trash"></i></a>`
                        return html;
                    }
                }
            ]
        })

        this.targetsDatatable = this.dom.find("#datatable_targets").DataTable({
            "processing": true,
            "serverSide": true,
            "ordering": false,
            "ajax": {
                "url": "api/attendance/searchtargets",
                "data": (d) => {
                    d.data = this.filterData;
                    d.meeting_id = this.config.meetingData.meeting_id
                }
            },
            "columns": [
                {"mDataProp": "customer_id"},
                {"mDataProp": "firstname"},
                {"mDataProp": "lastname"},
                {"mDataProp": "degree"},
                {"mDataProp": "specialty"},
                {"mDataProp": "address"},
                {"mDataProp": "city"},
                {"mDataProp": "state"},
                {"mDataProp": "email"},
                {
                    data: 'null',
                    render: (data, type, row) => {

                        // check to see if target is already in this groups
                        if(!this.members.find(({target_id}) => target_id == row.target_id))
                        {
                            return '<button type="button" class="btn btn-sm btn-primary add" data-target-id="' + row.target_id + '" data-address-id="' + row.address_id + '" data-address-index="' + row.address_index + '" data-name="' +  row.firstname + ' ' +  row.lastname + '" data-customer-id="' + row.customer_id +'"> Add</button>';
                        }
                        else
                        {
                            return '';
                        }
                    }
                }
            ],
            "pagingType": "full_numbers",
            "width" : "100%",
            "dom": '<"row"<"col-6"l><"col-6"<"row">>><t>pri',
            "deferLoading": 1,
            "pageLength": 10,
            "scrollCollapse": true,
            "scrollY": '50vh',
            "language": {
                "loadingRecords": 'Please wait while we fetch your results.',
                "emptyTable":     "No Results",
                "processing": 'Please wait while we fetch your results.'
            },
            "drawCallback": function() {
                app.convertDatatableToCard("datatable_targets");
            }
        });
    }
}
